

import React, { useState, useEffect } from "react";
import { coursesAPI, uploadsAPI } from "../services/api";
import { useNavigate } from "react-router-dom";
import { FILE_BASE_URL } from "../config";
import "../styles/ViewLectures.css";
import { FaFilePdf, FaFileVideo, FaFileAlt, FaChalkboardTeacher, FaEdit, FaTrash } from "react-icons/fa";

const ViewLectures = () => {
  const [lectures, setLectures] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLectures = async () => {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        navigate("/login");
        return;
      }

      try {
        const coursesResponse = await coursesAPI.getAll();
        const courses = coursesResponse.data;

        let allLectures = [];

        await Promise.all(courses.map(async (course) => {
          try {
            const lecturesResponse = await uploadsAPI.getLectures(course.id);
            const courseLectures = lecturesResponse.data.map(lecture => ({
              ...lecture,
              courseName: course.title,
              courseId: course.id
            }));
            allLectures = [...allLectures, ...courseLectures];
          } catch (err) {
            console.warn(`Failed to fetch lectures for course ${course.id}`, err);
          }
        }));

        setLectures(allLectures);
      } catch (error) {
        console.error("❌ خطأ في جلب المحاضرات:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLectures();
  }, [navigate]);

  const handleDelete = async (lectureId) => {
    if (window.confirm("هل أنت متأكد من حذف هذه المحاضرة؟")) {
      try {
        await uploadsAPI.deleteLecture(lectureId);
        setLectures(prev => prev.filter(l => l.id !== lectureId));
        alert("✅ تم الحذف بنجاح");
      } catch (e) {
        console.error("Delete error:", e);
        alert("❌ فشل الحذف");
      }
    }
  };

  const getFileIcon = (filePath) => {
    if (!filePath) return <FaFileAlt className="file-icon generic" />;
    if (filePath.endsWith('.pdf')) return <FaFilePdf className="file-icon pdf" />;
    if (filePath.endsWith('.mp4')) return <FaFileVideo className="file-icon video" />;
    return <FaFileAlt className="file-icon generic" />;
  };

  return (
    <div className="lectures-page">
      <div className="page-header">
        <h2>📚 مكتبة المحاضرات</h2>
        <button className="btn-primary" onClick={() => navigate("/upload")}>
          📤 رفع محاضرة جديدة
        </button>
      </div>

      {loading ? (
        <p className="loading-text">⏳ جاري تحميل المحاضرات...</p>
      ) : lectures.length > 0 ? (
        <div className="lectures-grid">
          {lectures.map((lecture) => (
            <div key={lecture.id} className="lecture-card">
              <div className="lecture-icon-wrapper">
                {getFileIcon(lecture.file_path)}
              </div>
              <div className="lecture-content">
                <h3 className="lecture-title">{lecture.title}</h3>
                <span className="course-badge"><FaChalkboardTeacher /> {lecture.courseName}</span>
                <p className="lecture-description">{lecture.description || "لا يوجد وصف"}</p>

                <div className="lecture-actions" style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                  <button
                    onClick={() => navigate(`/edit-lesson/${lecture.courseId}/${lecture.id}`)}
                    title="تعديل"
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#f59e0b' }}
                  >
                    <FaEdit size={18} />
                  </button>
                  <button
                    onClick={() => handleDelete(lecture.id)}
                    title="حذف"
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444' }}
                  >
                    <FaTrash size={18} />
                  </button>
                  {lecture.file_path && (
                    <a
                      href={`${FILE_BASE_URL}${lecture.file_path}?token=${localStorage.getItem("authToken")}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-view"
                      style={{ marginLeft: 'auto' }}
                    >
                      عرض الملف
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <p>🚫 لا توجد محاضرات متاحة حالياً.</p>
          <button className="btn-outline" onClick={() => navigate("/upload")}>
            ابدأ برفع أول محاضرة
          </button>
        </div>
      )}
    </div>
  );
};

export default ViewLectures;
